/*
 * File: /src/mixins/formatPhone.js
 * Created Date: Saturday August 21st 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 21st August 2021 8:07:48 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { parsePhoneNumber } from 'awesome-phonenumber';

import voiceServices from 'src/services/voiceServices';

export default {
  methods: {
    formatPhoneNumber(number) {
      if (typeof number !== 'string' || !number) {
        // Seems dangerous to consume the input and drop it without
        // any error or warning
        return '';
      }
      let phoneNumber;
      try {
        phoneNumber = parsePhoneNumber(number);
      } catch (e) {
        console.error('Phone number error: ' + number + ': ' + e);
        return number;
      }

      if (phoneNumber.valid) {
        if (phoneNumber.regionCode === 'US') {
          return phoneNumber.number?.national;
        }
        return phoneNumber.number?.international;
      }
      return number;
    },
    phoneNumberDial(number) {
      if (typeof number !== 'string') {
        return '';
      }
      try {
        const phoneNumber = parsePhoneNumber(number, { regionCode: 'US' });
        if (phoneNumber.valid) {
          // awesome-phonenumber doesn't have a direct getURI equivalent
          // we need to format it as tel:[E.164 format]
          return 'tel:' + phoneNumber.number?.e164;
        }
      } catch (e) {
        console.error('Phone dial error: ' + number + ': ' + e);
      }
      return '';
    },
    async callContact(contactId, toNumber, callerId) {
      // Route to initiate outbound call.
      try {
        // For now callerId is just a FromNumberId
        const call = await voiceServices.callContact(
          contactId,
          toNumber,
          callerId
        );
        this.$message({
          message:
            call.status === 200 || call.status === 204
              ? 'Calling you... '
              : 'Error initiating call',
          type:
            call.status === 200 || call.status === 204 ? 'success' : 'error',
        });
      } catch (e) {
        console.log('error initiating call', e);
        let msg = 'Error initiating the call';
        switch (+e.response.status) {
          case 424:
            msg = 'Agent phone number not found';
            break;
          case 422:
            msg = 'Contact phone number not found';
            break;
        }
        this.$message({
          message: msg,
          type: 'error',
        });
      }
    },
  },
};
